import {
	ChangeDetectionStrategy,
	Component,
	effect,
	inject,
	input,
	output,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { MatButtonModule } from '@angular/material/button';
import {
	CdkDrag,
	CdkDragDrop,
	CdkDragHandle,
	CdkDropList,
	moveItemInArray,
} from '@angular/cdk/drag-drop';

@Component({
	selector: 'routine-tasks-tab',
	imports: [
		NgxTolgeeModule,
		MatIconModule,
		MatFormFieldModule,
		MatInputModule,
		ReactiveFormsModule,
		MatButtonModule,
		CdkDropList,
		CdkDrag,
		CdkDragHandle,
		CdkDrag,
	],
	templateUrl: './routine-tasks-tab.component.html',
	styleUrl: './routine-tasks-tab.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoutineTasksTabComponent {
	private readonly fb = inject(FormBuilder);

	template = input<string>();
	canEditTemplate = input<boolean>(true);

	tasksForm = this.fb.group({
		questions: this.fb.array<FormControl<string>>([]),
	});

	updateData = output<{ checklistQuestions: string[] }>();

	constructor() {
		effect(() => {
			const templateValue = this.template();
			if (templateValue) {
				const parsedTemplate = JSON.parse(templateValue);
				const questionsList = parsedTemplate.options?.map(option => option.question);
				this.buildQuestionsForm(questionsList);
			}
			if (!this.canEditTemplate()) {
				this.tasksForm.disable();
				return;
			}
			this.tasksForm.enable();
		});
	}

	get questionsFormArray() {
		return this.tasksForm.get('questions') as FormArray;
	}

	private buildQuestionsForm(questions: string[]) {
		this.questionsFormArray.clear();
		if (questions) {
			questions.forEach(question => {
				this.questionsFormArray.push(this.fb.control(question));
			});
		}
	}

	addQuestion() {
		const controls = this.questionsFormArray.controls;

		if (controls[controls.length - 1]?.value.trim() === '' && controls.length > 0) {
			return;
		}

		this.questionsFormArray.push(this.fb.control(''));
	}

	removeQuestion(index: number) {
		this.questionsFormArray.removeAt(index);
		this.emitFormValues();
	}

	emitFormValues() {
		const validQuestions = this.questionsFormArray.value.filter(
			(q: string) => q || q.trim() !== ''
		);
		this.updateData.emit({ checklistQuestions: validQuestions });
	}

	drop(event: CdkDragDrop<FormControl[]>) {
		moveItemInArray(
			this.questionsFormArray.controls,
			event.previousIndex,
			event.currentIndex
		);
		this.questionsFormArray.updateValueAndValidity();
		this.emitFormValues();
	}
}
